import { render, staticRenderFns } from "./ActionListApprove.vue?vue&type=template&id=25174c91&"
import script from "./ActionListApprove.vue?vue&type=script&lang=ts&"
export * from "./ActionListApprove.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports